import axios from 'axios';

export default {
	postSubmitForm(cb, { data, dealerId, clientToken }) {
		axios
			.post('/api/DigitalLead',
				data, {
					headers: {
						Authorization: `Bearer ${clientToken}`,
						Dealer: dealerId
					} })
			.then(response => response.data)
			.then(data => {
				cb(data);
			})
			.catch(err => cb(err.response));
	},
};
